module.exports = __webpack_public_path__ + "static/media/full-screen.93555aa9.svg";